import { Stack } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { Handle, Position } from '@xyflow/react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ApprovalLevelViewRowValues, ApprovalValues } from '../../../types';
import { movingNodeId } from '../../ApproverLevels';
import { setNodeScrollState } from '../../Conditions';
import { Add } from '../common/Add';
import { FormView } from './FormView';

// @ts-ignore
export const AddLevelNode: React.FC = ({ data, isConnectable }) => {

  const calloutId = useId(`AddLevelNode-callOutId`);
  const [visibility, setVisibility] = useState(false);
  const { getValues, setValue } = useFormContext<ApprovalValues>();

  const handleAddLevel = (data: ApprovalLevelViewRowValues) => {
    const approvalTreesFormValues = getValues('approvalTrees') || [];
    const highestOrder = approvalTreesFormValues
      .map((item) => (item.approvalLevel ? item.approvalLevel : 0))
      .sort((a, b) => b - a)?.[0];

    const updatedApprovalTrees = [
      ...approvalTreesFormValues.slice(0, -1),
      {
        ...data,
        approvalLevel: highestOrder + 1,
      },
      { ...approvalTreesFormValues[approvalTreesFormValues.length - 1] },
    ];
    setValue('approvalTrees', updatedApprovalTrees, {
      shouldDirty: true,
    });
    setNodeScrollState(true);
    setVisibility(false); // optionally close the Callout
  };
  const movingNode = movingNodeId();

  return (
    <Stack style={{ opacity: movingNode ? 0.5 : 1 }}>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
      />
      {data && (
        <Add
          title="Add Level"
          id={calloutId}
          onClick={() => {
            setVisibility(true);
            setNodeScrollState(false);
          }}
        />
      )}

      <FormView
        onClose={() => {
          setNodeScrollState(true);
          setVisibility(false);
        }}
        onSave={handleAddLevel}
        visibility={visibility}
      />
    </Stack>
  );
};
